import React from "react";
import PrivacyPolicyView from "views/static/PrivacyPolicy";

function PrivacyPolicy() {
  return <PrivacyPolicyView />;
}
export default PrivacyPolicy;
